// extracted by mini-css-extract-plugin
export default {"main-content-wrapper":"AddTagsDialog_main-content-wrapper__Gps04","selected-tags":"AddTagsDialog_selected-tags__MUH0M"};